<template>
  <vx-card v-if="rule" no-shadow>
    <div class="vx-row mb-6 mt-2">
      <div class="vx-col sm:w-4/5 w-full">
        <h2 style="font-size: revert; font-weight: 500">Notification rule</h2>
        <small>Last edit: {{ rule.savedAction.timestamp | formatDate }} by {{ rule.savedAction.userDisplayName }}</small>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Rule country</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <code>
          {{ rule.country }}
        </code>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Enable notification rule</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-switch color="success" v-model="rule.enabled" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Rule triggers on</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-select label="Meeting" multiple v-model="rule.meetingIds" class="w-full max-w-md">
          <vs-select-item :key="meeting.id" :value="meeting.id" :text="meeting.title" v-for="meeting in allMeetingsForCountry" />
        </vs-select>
      </div>
    </div>

    <div v-if="rule.type === 'onInactivityMeetingNotificationRule'" class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Time since last time this meeting was held</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-select label="Notification is sent when this is exceeded" v-model="rule.inactivityPeriod" class="w-full max-w-md">
          <vs-select-item :key="idx" :value="interval.time" :text="interval.name" v-for="(interval, idx) in inactivityIntervals" />
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Who should receive notification?</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-select multiple v-model="rule.recipientRoles" class="w-full max-w-md">
          <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'" v-for="(role, idx) in roles" />
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Notification channels</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row><span>LIFE app</span><vs-switch class="ml-2" color="success" v-model="rule.sendInApp" /></vs-row>
        <vs-row class="mt-2"><span>LIFE Workspace</span><vs-switch class="ml-2" color="success" v-model="rule.sendInVp" /></vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Notification title</span>
      </div>

      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea placeholder="Text message" v-model="rule.title" />
        <div @click="addTitlePlaceholder(ph)" class="cursor-pointer" v-for="(ph, idx) in placeholders" :key="idx">
          <vs-chip>
            {{ ph }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Notification message</span>
      </div>

      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea placeholder="Text message" v-model="rule.message" />
        <div @click="addMessagePlaceholder(ph)" class="cursor-pointer" v-for="(ph, idx) in placeholders" :key="idx">
          <vs-chip>
            {{ ph }}
          </vs-chip>
        </div>
      </div>
    </div>

    <!-- Save & Remove Button -->
    <vs-row vs-justify="space-between" class="flex flex-wrap items-center mt-6">
      <vs-button @click="update">Save changes</vs-button>
      <vs-button color="danger" @click="promptDelete">Delete rule</vs-button>
    </vs-row>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},

  data() {
    return {
      id: null
    };
  },
  methods: {
    async update() {
      await this.$store.dispatch("meetingRules/updateRule", this.rule);
      this.$vs.notify({
        title: "Saved",
        text: "Successfully saved rule"
      });
    },
    async promptDelete() {
      this.$vs.dialog({
        color: "danger",
        title: `Are you sure?`,
        text: "Are you sure you want to delete this notification rule?",
        accept: this.remove
      });
    },
    async remove() {
      const activeCountry = this.$store.getters["venues/activeCountry"];
      await this.$store.dispatch("meetingRules/deleteRule", { id: this.rule.id, country: activeCountry.id });
      this.$router.go(-1);
    },
    addTitlePlaceholder(ph) {
      this.rule.title = `${this.rule.title}{{${ph}}}`;
    },
    addMessagePlaceholder(ph) {
      this.rule.message = `${this.rule.message}{{${ph}}}`;
    }
  },
  computed: {
    ...mapGetters({
      rule: "meetingRules/rule",
      questionCategories: "lists/questionCategories",
      placeholders: "meetingRules/placeholders",
      inactivityIntervals: "meetingRules/inactivityIntervals",
      roles: "roles",
      allMeetingsForCountry: "meetings/all",
      activeCountryId: "venues/activeCountryId"
    })
  },
  async created() {
    this.id = this.$route.params.id;

    // await all
    await Promise.all([
      this.$store.dispatch("meetingRules/getRule", this.id),
      this.$store.dispatch("getRoles"),
      this.$store.dispatch("meetings/getAll", {country: this.activeCountryId})
    ]);

    console.log("Rule", this.rule);
  }
};
</script>
